<template>
  <div class="content_box mt-4">
    <v-row>
      <v-col cols="12">
        <sessions-grid-tab ref="sessionsGridTab">
        </sessions-grid-tab>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import SessionsGridTab from './sessions-grid-tab.vue';

export default {
  name: 'TodaySessionsPage',
  components: { SessionsGridTab },
  data() {
    return {};
  },
  computed: {},
  mounted() { },
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>
